import { render, staticRenderFns } from "./CoverType.vue?vue&type=template&id=70dc781a"
import script from "./CoverType.vue?vue&type=script&lang=js"
export * from "./CoverType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports